import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AutosaveStatus = 'idle' | 'saving' | 'saved' | 'error';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
}

interface UiState {
  autosaveStatus: AutosaveStatus;
  snackbar: SnackbarState;
}

const initialState: UiState = {
  autosaveStatus: 'idle',
  snackbar: { open: false, message: '', severity: 'info' },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setAutosaveStatus(state, action: PayloadAction<AutosaveStatus>) {
      state.autosaveStatus = action.payload;
    },
    showSnackbar(state, action: PayloadAction<{ message: string; severity?: SnackbarState['severity'] }>) {
      state.snackbar = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity ?? 'info',
      };
    },
    hideSnackbar(state) {
      state.snackbar.open = false;
    },
  },
});

export const { setAutosaveStatus, showSnackbar, hideSnackbar } = uiSlice.actions;
export default uiSlice.reducer;
